import {
  AnalyticsApi,
  APIKeysApi,
  CatalogueTemplatesApi,
  CataloguesApi,
  CategoriesApi,
  Configuration,
  ModerationApi,
  ProductsApi,
  ReviewApi,
  StatisticsApi,
  TokensApi,
} from "@sakura-tech-lab/dashboard-api";

import { API_BASE_URL } from "@/constants/api";

const configuration = new Configuration({
  basePath: API_BASE_URL,
  credentials: "include",
});

export const catalogueTemplatesApi = new CatalogueTemplatesApi(configuration);
export const analyticsApi = new AnalyticsApi(configuration);
export const cataloguesApi = new CataloguesApi(configuration);
export const categoriesApi = new CategoriesApi(configuration);
export const moderationApi = new ModerationApi(configuration);
export const apiKeysApi = new APIKeysApi(configuration);
export const productsApi = new ProductsApi(configuration);
export const reviewApi = new ReviewApi(configuration);
export const statisticsApi = new StatisticsApi(configuration);
export const tokensApi = new TokensApi(configuration);
